import * as yup from 'yup';
import generateRender from '../../utils/generateRender';
/**
 * Initial values
 */

var defaultInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  acceptedTerms: false,
  emailOptIn: false
};
var hriInitialValues = {
  email: '',
  password: '',
  confirmPassword: '',
  acceptedTerms: false,
  emailOptIn: false
};
/**
 * Validation schemas
 */

var defaultValidationSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email format').required('Email is required'),
  password: yup.string().min(6, 'Your password must be at least 6 characters long.').required('Password is required'),
  confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Your passwords did not match').required('Please confirm your password')
});
var hriValidationSchema = yup.object({
  email: yup.string().email('Invalid email format').required('Email is required'),
  password: yup.string().min(6, 'Your password must be at least 6 characters long.').required('Password is required'),
  confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Your passwords did not match').required('Please confirm your password')
});
/**
 * Output
 */

export var initialValues = generateRender({
  default: defaultInitialValues,
  hri: hriInitialValues
});
export var validationSchema = generateRender({
  default: defaultValidationSchema,
  hri: hriValidationSchema
});